import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { EntityType } from '../comment';

export class Tag extends CompanyEntity {
  name!: string;
  type!: EntityType;
  description?: string;
  color!: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
    this.color ||= Tag.getRandomColor();
  }

  static getRandomColor() {
    return hexColors[Math.ceil(Math.random() * hexColors.length) - 1];
  }
}

const hexColors = [
  '#4E5BA6',
  '#5D6B98',
  '#697586',
  '#6C737F',
  '#70707B',
  '#737373',
  '#79716B',
  '#669F2A',
  '#66C61C',
  '#16B364',
  '#15B79E',
  '#06AED4',
  '#0BA5EC',
  '#2E90FA',
  '#2970FF',
  '#6172F3',
  '#875BF7',
  '#7A5AF8',
  '#D444F1',
  '#EE46BC',
  '#F63D68',
  '#FF4405',
  '#EF6820',
  '#EAAA08',
];
